import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';
import { MediaCategory } from '@src/api/types/mediaCategory';

type MediaCategoryIndexResponse = MediaCategory[];
type MediaCategoryUpdateRequest = {
  name?: string;
  viewable?: number;
  order?: number;
};

type MediaCategoryUpdateOrderRequest = {
  orders: {
    id: number;
    order: number;
  }[];
};

export const mediaCategoryApiClient = {
  index: async (): Promise<ApiResult<MediaCategoryIndexResponse>> => {
    return await axiosClient.get('/tenant/media-categories');
  },
  show: async (id: number): Promise<ApiResult<MediaCategory>> => {
    return await axiosClient.get(`/tenant/media-categories/${id}`);
  },
  update: async (id: number, params: MediaCategoryUpdateRequest): Promise<ApiResult> => {
    return await axiosClient.put(`/tenant/media-categories/${id}`, params);
  },
  updateOrder: async (params: MediaCategoryUpdateOrderRequest): Promise<ApiResult> => {
    return await axiosClient.put('/tenant/media-categories/order', params);
  },
};
